import React, { useEffect, useRef, useState } from 'react';
import img from "../../assets/profiledefaultimg.webp"
import "./LiveExam.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { submitTest } from '../../actions/testActions';
import { useDispatch, useSelector } from 'react-redux';
import GetfirstAndLastName from '../common/GetfirstAndLastName';
import { fetchUserDataRequest } from '../../actions/dashboardActions';

const
    LiveExam = () => {
        const location = useLocation();
        const { test, studentProfileData: stateStudentProfileData } = location?.state || {}
        const testSubmitted = useSelector(state => state.tests.testSubmitted);
        const questions = test?.questions || []; // Assuming questions is an array of question objects
        const [currentQuestion, setCurrentQuestion] = useState(questions[0]);
        const [userAnswers, setUserAnswers] = useState(Array(questions?.length).fill(null));
        const [remainingTime, setRemainingTime] = useState(); // Remaining time in seconds
        const [isSubmitting, setIsSubmitting] = useState(false);
        const [showFullScreenPrompt, setShowFullScreenPrompt] = useState(true); // Show full-screen prompt
        const [showMobileSidebar, setShowMobileSidebar] = useState(false); // Control mobile sidebar visibility
        const [isLastQuestion, setIsLastQuestion] = useState(false);
        const examDurationInMinutes = test?.totalMinutes; // Example duration, replace it with your backend value
        const endTime = useRef(null); // Use useRef to store the end time
        const containerRef = useRef(null); // Reference to the container for full screen
        const navigate = useNavigate()
        const dispatch = useDispatch()
        const reduxSateUserData = useSelector(state => state.dashboard.userData)
        const studentProfileData = stateStudentProfileData ? stateStudentProfileData : reduxSateUserData;

        const examDurationInSeconds = examDurationInMinutes * 60;

        useEffect(() => {
            if (!stateStudentProfileData && !reduxSateUserData) {
                dispatch(fetchUserDataRequest());
            }
        }, []);

        // Check if current question is the last one
        useEffect(() => {
            const isLast = currentQuestion.questionNumber === questions.length;
            setIsLastQuestion(isLast);
        }, [currentQuestion, questions]);
        const handleFullScreen = () => {
            if (containerRef.current.requestFullscreen) {
                containerRef.current.requestFullscreen();
            } else if (containerRef.current.webkitRequestFullscreen) { // Safari
                containerRef.current.webkitRequestFullscreen();
            } else if (containerRef.current.msRequestFullscreen) { // IE/Edge
                containerRef.current.msRequestFullscreen();
            }
            setShowFullScreenPrompt(false); // Hide the prompt after entering full-screen

        };

        const handleFullScreenChange = () => {
            if (
                !document.fullscreenElement &&
                !document.webkitFullscreenElement &&
                !document.msFullscreenElement
            ) {
                // User exited full-screen mode
                setShowFullScreenPrompt(true);
            }
        };

        useEffect(() => {
            // Add event listener for full-screen changes
            document.addEventListener("fullscreenchange", handleFullScreenChange);
            document.addEventListener("webkitfullscreenchange", handleFullScreenChange); // Safari
            document.addEventListener("msfullscreenchange", handleFullScreenChange); // IE/Edge

            return () => {
                // Cleanup event listeners
                document.removeEventListener("fullscreenchange", handleFullScreenChange);
                document.removeEventListener("webkitfullscreenchange", handleFullScreenChange);
                document.removeEventListener("msfullscreenchange", handleFullScreenChange);
            };
        }, []);



        const userAnswersRef = useRef(userAnswers);
        useEffect(() => {
            userAnswersRef.current = userAnswers;
        }, [userAnswers]);

        // Calculate remaining time and update every second
        useEffect(() => {
            endTime.current = new Date();
            endTime.current.setSeconds(endTime.current.getSeconds() + examDurationInSeconds);
            const timer = setInterval(() => {
                const now = new Date();
                const difference = Math.floor((endTime.current - now) / 1000); // Difference in seconds
                setRemainingTime(difference > 0 ? difference : 0);
                // Stop the timer when time runs out
                if (difference <= 0) {
                    clearInterval(timer);
                    handleSubmitTest(); // Automatically submit the test when time runs out
                }
            }, 1000);

            // Cleanup function
            return () => clearInterval(timer);
        }, [examDurationInSeconds]);



        // Format remaining time for display
        const formatTime = (timeInSeconds) => {
            const minutes = Math.floor(timeInSeconds / 60);
            const seconds = timeInSeconds % 60;
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        };


        // Submit the test data to the backend
        const handleSubmitTest = async () => {
            setIsSubmitting(true);
            const latestUserAnswers = userAnswersRef.current;
            const data = {
                userAnswers: latestUserAnswers,
                testId: test._id,
                name: studentProfileData?.name,
                submitterId: studentProfileData?._id
            };
            try {
                dispatch(submitTest(data));
            } catch (error) {
                console.error('Submission failed:', error);
            }
        };


        useEffect(() => {
            if (testSubmitted) {
                navigate('/exam-result', { state: { test, userAnswers: userAnswersRef.current } });
            }
        }, [testSubmitted, navigate]);
        // Submit the test data to the backend



        // all buttons

        const handleNext = () => {
            // Implement logic to go to the next question
            const currentIndex = questions.findIndex(q => q.questionNumber === currentQuestion.questionNumber);
            const nextIndex = (currentIndex + 1) % questions.length;

            if (nextIndex === 0) {
                // Reached the end of questions
                // Handle end of questions behavior here

            } else {
                // setCurrentQuestion(questions[nextIndex]);
                setCurrentQuestion({
                    ...questions[nextIndex],
                    answer: userAnswers[questions[nextIndex].questionNumber - 1]
                });
            }
        };

        const handlePrevious = () => {
            // Implement logic to go to the previous question
            const currentIndex = questions.findIndex(q => q.questionNumber === currentQuestion.questionNumber);
            const previousIndex = (currentIndex - 1 + questions.length) % questions.length;
            setCurrentQuestion({
                ...questions[previousIndex],
                answer: userAnswers[questions[previousIndex].questionNumber - 1]
            });

        };

        const handleSave = () => {
            // Implement logic to save the current state or answer 
            const updatedUserAnswers = [...userAnswers];
            const currentQuestionIndex = questions.findIndex(q => q.questionNumber === currentQuestion.questionNumber);

            updatedUserAnswers[currentQuestionIndex] = currentQuestion.answer == null ? userAnswers[currentQuestionIndex] : currentQuestion.answer;
            setUserAnswers(updatedUserAnswers);

        };


        const handleClearResponse = () => {
            const currentQuestionIndex = questions.findIndex(q => q.questionNumber === currentQuestion.questionNumber);

            setUserAnswers(prevUserAnswers => {
                const updatedUserAnswers = [...prevUserAnswers];
                updatedUserAnswers[currentQuestionIndex] = null;
                return updatedUserAnswers;
            });
            setCurrentQuestion(prevQuestion => ({
                ...prevQuestion,
                answer: null
            }));
        };

        const handleOptionChange = (index) => {
            if (currentQuestion.type === 'multiple') {
                // For multiple choice questions
                const currentAnswers = Array.isArray(currentQuestion.answer) ? [...currentQuestion.answer] : [];
                const answerIndex = currentAnswers.indexOf(index);

                if (answerIndex === -1) {
                    currentAnswers.push(index);
                } else {
                    currentAnswers.splice(answerIndex, 1);
                }

                setCurrentQuestion(prevQuestion => ({
                    ...prevQuestion,
                    answer: currentAnswers,
                    answered: currentAnswers.length > 0
                }));
            } else {
                // For single choice questions
                setCurrentQuestion(prevQuestion => ({
                    ...prevQuestion,
                    answer: index,
                    answered: true
                }));
            }
        };

        const handelSaveAndNext = () => {

            handleSave();
            if (!isLastQuestion) {
                handleNext();
            }
        }

        const isOptionSelected = (index) => {
            if (currentQuestion.type === 'multiple') {
                return Array.isArray(currentQuestion.answer) && currentQuestion.answer.includes(index);
            } else {
                return currentQuestion.answer === index;
            }
        };

        const hasAnswerForCurrentQuestion = () => {
            const currentQuestionIndex = questions.findIndex(q => q.questionNumber === currentQuestion.questionNumber);
            return userAnswers[currentQuestionIndex] !== null;
        };

        const attemptedQuestions = () => questions.filter((question, index) => userAnswers[index] !== null);
        const remainingQuestions = () => questions.filter((question, index) => userAnswers[index] === null);


        // all buttons
        return (
            <div ref={containerRef} style={{ backgroundColor: "#ffffff" }}>
                {showFullScreenPrompt && (
                    <div className="fullscreen-prompt">
                        <div className="fullscreen-modal ">
                            <p>This exam runs only in full-screen mode. Ready to begin?</p>
                            <button className="btn button-design " style={{ marginRight: "1rem" }} onClick={handleFullScreen}>
                                Yes
                            </button>
                            <button className="btn btn-secondary gap-3" onClick={() => navigate(-1)}>
                                No
                            </button>
                        </div>
                    </div>
                )}
                {!showFullScreenPrompt && (
                    <>
                        {/* Navbar */}
                        <nav className="navbar" data-bs-theme="dark" style={{ backgroundColor: "#0096c7" }}>
                            <div className="container-fluid d-flex justify-content-between align-items-center">
                                <div className="navbar-brand mb-0">{test.testName}</div>
                                <div className="navbar-brand mb-0">
                                    <span className="d-none d-md-inline">Time Left: </span>
                                    <span>{formatTime(remainingTime)}</span>
                                </div>
                            </div>
                        </nav>

                        {/* Mobile Header - Toggle Sidebar Button and Summary */}
                        <div className="d-md-none d-flex justify-content-between align-items-center p-2 bg-light border-bottom">
                            <button
                                className={`btn ${showMobileSidebar ? 'btn-primary' : 'btn-outline-primary'} d-flex align-items-center px-3 py-2`}
                                onClick={() => setShowMobileSidebar(!showMobileSidebar)}
                            >
                                <i className={`fas ${showMobileSidebar ? 'fa-chevron-left' : 'fa-chevron-right'} me-2`}></i>
                                {showMobileSidebar ? 'Hide Summary' : 'Show Summary'}
                            </button>

                            <div className="d-flex align-items-center">
                                <span className="badge bg-success m-1 d-flex align-items-center"
                                    style={{ fontSize: '0.8rem', padding: '5px 6px' }}
                                >
                                    Answered: {attemptedQuestions().length}
                                </span>
                                <span className="badge bg-warning m-1 d-flex align-items-center"
                                    style={{ fontSize: '0.8rem', padding: '5px 6px' }}
                                >
                                    Pending: {remainingQuestions().length}
                                </span>
                            </div>
                        </div>



                        {/* Main Content */}
                        <div className="container-fluid flex-grow-1">
                            <div className="row">
                                {/* Left Panel - Question Area */}
                                <div className="col-md-9 d-flex flex-column  overflow-hidden" style={{ height: "calc(100vh - 56px)" }}>
                                    <div className="flex-grow-1 overflow-auto p-3">
                                        <h3>Question {currentQuestion.questionNumber}</h3>
                                        <p dangerouslySetInnerHTML={{ __html: currentQuestion.questionText }} />

                                        <form>
                                            <ul>
                                                {currentQuestion.options.map((option, index) => (
                                                    <li className='licss' key={index}>
                                                        <label>
                                                            <input
                                                                type={currentQuestion.type === 'multiple' ? 'checkbox' : 'radio'}
                                                                className="m-2"
                                                                name={`question-${currentQuestion.questionNumber}`}
                                                                value={option}
                                                                onChange={() => handleOptionChange(index)}
                                                                checked={isOptionSelected(index)}
                                                            />
                                                            {option}
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        </form>
                                    </div>

                                    {/* Desktop view */}
                                    <div className="d-none d-md-flex justify-content-between p-3 border-top">
                                        <div>
                                            <button className="btn btn-danger"
                                                onClick={handleSubmitTest}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Submitting...
                                                    </>
                                                ) : (
                                                    "Submit Test"
                                                )}</button>


                                        </div>
                                        <div>
                                            <button className="btn btn-warning mx-2" onClick={handleClearResponse}>Clear Response</button>
                                            <button className="btn btn-primary" onClick={handlePrevious}>Previous</button>
                                            {isLastQuestion && hasAnswerForCurrentQuestion() ? null : (
                                                isLastQuestion ? (
                                                    <button className="btn btn-success mx-2" onClick={handleSave}>Save</button>
                                                ) : (
                                                    <button className="btn btn-success mx-2" onClick={handelSaveAndNext}>Save & Next</button>
                                                )
                                            )}
                                        </div>
                                    </div>



                                    {/* Mobile view */}
                                    <div className="d-md-none p-3 pt-2 border-top">
                                        <div className="d-flex justify-content-between mb-2">
                                            {isLastQuestion && hasAnswerForCurrentQuestion() ? (
                                                <button className="btn btn-primary w-100" onClick={handlePrevious}>Previous</button>) : (
                                                <button className="btn btn-primary w-50 me-1" onClick={handleNext}>Next</button>)
                                            }
                                            {isLastQuestion && hasAnswerForCurrentQuestion() ? null : (
                                                isLastQuestion ? (
                                                    <button className="btn btn-success w-50 ms-1" onClick={handleSave}>Save</button>
                                                ) : (
                                                    <button className="btn btn-success w-50 ms-1" onClick={handelSaveAndNext}>Save & Next</button>
                                                )
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <button className="btn btn-warning w-100" onClick={handleClearResponse}>Clear Response</button>
                                        </div>
                                        <div className="position-fixed bottom-0 start-0 end-0 p-2 bg-white border-top shadow" style={{ zIndex: 1000 }}>
                                            <button className="btn btn-danger w-100"
                                                onClick={handleSubmitTest}
                                                disabled={isSubmitting}

                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Submitting...
                                                    </>
                                                ) : (
                                                    "Submit Test"
                                                )}</button>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Panel - Profile + Question Palette */}
                                <div className={`col-md-3 d-flex flex-column vh-100 border-start ${showMobileSidebar ? 'd-block' : 'd-none'} d-md-block`}>                                    {/* Header Info */}
                                    <div className="p-3">
                                        <div className="d-flex align-items-center">
                                            <img src={studentProfileData.imagepath || img} alt="User Profile" className="img-fluid rounded-circle" style={{ maxWidth: '100px' }} />
                                            <div className="ms-2">
                                                <h5 className="mb-0">{GetfirstAndLastName(studentProfileData?.name)}</h5>
                                            </div>
                                        </div>
                                        <p className="mt-3">  You are currently attempting the <strong>{test.testName}</strong> exam. Best of luck! </p>

                                        <button className="btn btn-success m-1 w-100">Answered {attemptedQuestions().length}</button>
                                        <button className="btn btn-warning m-1 w-100">Pending {remainingQuestions().length}</button>
                                        {/* <button className="btn btn-outline-secondary m-1 w-100" onClick={handleFullScreen}>Full Screen</button> */}
                                    </div>

                                    {/* Scrollable Question Palette */}
                                    <div className="flex-grow-1 px-3">
                                        <h5>Questions</h5>
                                        <div className="d-flex flex-wrap scrollable-palette">
                                            {questions.map((question) => (
                                                <>
                                                    <button
                                                        key={question.questionNumber}
                                                        className={`btn btn-outline-primary mb-2 me-2 question-button ${userAnswers[question.questionNumber - 1] !== null ? 'answered' : ''} ${question.questionNumber === currentQuestion.questionNumber ? 'active' : ''}`}
                                                        onClick={() => {
                                                            setCurrentQuestion({
                                                                ...question,
                                                                answer: userAnswers[question.questionNumber - 1],
                                                            })
                                                            setShowMobileSidebar(false); // Auto-hide sidebar on mobile after selecting question
                                                        }}
                                                    >
                                                        {question.questionNumber}
                                                    </button>
                                                </>

                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                    </>
                )}
            </div>





        );
    };

export default LiveExam;
